import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  items: [],
  countItems: 0,
  subtotal: 0.0,
  iva: 0.0,
  total: 0.0,
  shippingCosts: 0.0,
  totalWithDiscount: 0.0,
  discountCart: {
    type: '',
    quantity: 0,
    has_discount: false,
    code: '',
  },
  lastAddedItem: null,
  lastRemovedItem: null,
  isStorePickup: false,
  errorAmountPrice: false,
  isGiftOrder: false,
  giftData: {},
  giftCard: {},
  appliedCoupon: null,
  hasGiftCard: false,
  isShippingAvailable: { availability: true, message: '' },
  shippingCartAddress: {},
  billingCartAddress: {},
  contactInfo: {
    name: '',
    email_phone: '',
  },
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addItem: (state, action) => {
      const product = action.payload;
      console.log('%cADD / product', 'background: cornflowerblue; color: #bada55', product);

      product.iva = 4;

      const itemExists = state.items?.find((item) => product?.id === item?.id);
      if (itemExists) {
        itemExists.quantity += 1;
      } else {
        const newProduct = { ...product, ...{ quantity: 1 } };
        state.items.push(newProduct);
      }
      const pvp = Number(parseFloat(isNaN(product?.price) ? 0.0 : product?.price).toFixed(4));
      console.log('%cADD / pvp', 'background: navy; color: crimson', pvp);

      const pc = Number(((pvp * 100) / (100 + product.iva)).toFixed(4));
      console.log('%cADD / pc', 'background-color: navy; color: crimson', pc);

      const subtotal = Number((parseFloat(state.subtotal) + parseFloat(pc)).toFixed(4));
      console.log('%cADD / subtotal', 'background-color: navy; color: crimson', subtotal);

      const iva = Number((parseFloat(state.iva) + parseFloat(pvp) - parseFloat(pc)).toFixed(4));
      console.log('%cADD / iva', 'background-color: navy; color: crimson', iva);

      const total = Number((parseFloat(state.total) + pvp).toFixed(4));
      console.log('%cADD / total', 'background: navy; color: crimson', total);

      state.countItems += 1;

      state.iva = Number(iva.toFixed(4));
      state.subtotal = Number(subtotal.toFixed(4));
      state.total = Number(total.toFixed(4));
      state.lastAddedItem = action.payload?.titulo;
      state.isIncrease = true;

      if (product.type === 'book') {
        state.shippingCosts = 3.8;
      } else {
        state.shippingCosts = 0;
      }
    },
    removeItem: (state, action) => {
      const product = action.payload;
      state.items = state.items.filter((item) => product?.id !== item?.id);
      const pvp = Number(parseFloat(product.price).toFixed(4));
      const pc = Number(((pvp * 100) / (100 + product.iva)).toFixed(4));
      const subtotal = Number(((parseFloat(state.subtotal) - parseFloat(pc)) * product.quantity).toFixed(4));
      const iva = Number((parseFloat(state.iva) - (parseFloat(pvp) - parseFloat(pc)) * product.quantity).toFixed(4));
      const total = Number((parseFloat(state.total) - pvp) * parseFloat(product.quantity).toFixed(4));
      console.log('%cREM ITEM / total', 'background: navy; color: crimson', total);

      state.isIncrease = false;
      state.countItems -= product.quantity;

      if (state.countItems !== 0) {
        state.iva = Number(iva.toFixed(4));
        state.subtotal = Number(subtotal.toFixed(4));
        state.total = Number(total.toFixed(4));
        state.lastRemovedItem = action.payload.titulo;

        const hasBooks = state.items.some((item) => item.type === 'book');
        state.shippingCosts = hasBooks ? 3.8 : 0;
      } else {
        state.items = initialState.items;
        state.countItems = initialState.countItems;
        state.subtotal = Number(initialState.subtotal.toFixed(4));
        state.iva = Number(initialState.iva.toFixed(4));
        state.total = Number(initialState.total.toFixed(4));
        state.shippingCosts = initialState.shippingCosts;
        state.discountCart = initialState.discountCart;
        state.shippingCartAddress = {};
        state.billingCartAddress = {};
        state.isNewShippingAddress = false;
        state.isStorePickup = false;
        state.errorAmountPrice = initialState.errorAmountPrice;
        state.isGiftOrder = false;
        state.giftData = {};
        state.giftCard = {};
        state.appliedCoupon = null;
        state.hasGiftCard = initialState.hasGiftCard;
        state.isShippingAvailable = initialState.isShippingAvailable;
      }
    },
    increaseQuantity: (state, action) => {
      const id = action.payload;
      const itemExists = state.items.find((item) => id === item.id);

      const pvp = Number(parseFloat(itemExists.price).toFixed(4));
      const pc = Number(((pvp * 100) / (100 + itemExists.iva)).toFixed(4));
      const subtotal = Number((parseFloat(state.subtotal) + parseFloat(pc)).toFixed(4));
      const iva = Number((state.iva + parseFloat(pvp) - parseFloat(pc)).toFixed(4));
      const total = Number((parseFloat(state.total) + parseFloat(pvp)).toFixed(4));
      itemExists.quantity += 1;

      state.countItems += 1;
      state.iva = Number(iva.toFixed(4));
      state.subtotal = Number(subtotal.toFixed(4));
      state.total = Number(total.toFixed(4));
      state.isIncrease = true;
      state.lastAddedItem = itemExists.titulo;
    },
    setTotalWithDiscount: (state, action) => {
      state.totalWithDiscount = action.payload;
    },
    decreaseQuantity: (state, action) => {
      const id = action.payload;
      const itemExists = state.items.find((item) => id === item.id);
      if (itemExists.quantity === 1) {
        state.items = state.items.filter((item) => id !== item.id);
      } else {
        itemExists.quantity -= 1;
      }
      const pvp = Number(parseFloat(itemExists.price).toFixed(4));
      const pc = Number((pvp * 100) / (100 + itemExists.iva)).toFixed(4);
      const subtotal = Number((parseFloat(state.subtotal) - parseFloat(pc)).toFixed(4));
      const iva = Number((parseFloat(state.iva) - (parseFloat(pvp) - parseFloat(pc))).toFixed(4));
      const total = Number((parseFloat(state.total) - parseFloat(pvp)).toFixed(4));
      console.log('%cDEC QUANT / total', 'background: navy; color: yellow', total);

      state.countItems -= 1;

      state.iva = Number(iva.toFixed(4));
      state.subtotal = Number(subtotal.toFixed(4));
      state.total = Number(total.toFixed(4));
      state.isIncrease = false;
      state.lastRemovedItem = itemExists.titulo;
    },
    clear: (state, action) => {
      state.items = initialState.items;
      state.countItems = initialState.countItems;
      state.subtotal = Number(initialState.subtotal.toFixed(4));
      state.iva = Number(initialState.iva.toFixed(4));
      state.total = Number(initialState.total.toFixed(4));
      state.discountCart = initialState.discountCart;
      state.shippingCosts = initialState.shippingCosts;
      state.shippingCartAddress = {};
      state.billingCartAddress = {};
      state.isNewShippingAddress = false;
      state.isStorePickup = false;
      state.errorAmountPrice = initialState.errorAmountPrice;
      state.isGiftOrder = false;
      state.giftData = {};
      state.giftCard = {};
      state.appliedCoupon = null;
      state.hasGiftCard = initialState.hasGiftCard;
      state.isShippingAvailable = initialState.isShippingAvailable;
      state.contactInfo = initialState.contactInfo;
    },
    setShippingFee: (state, action) => {
      state.shippingCosts = Number(action.payload);
    },
    setShippingCartAddress: (state, action) => {
      state.shippingCartAddress = action.payload;
    },
    setBillingCartAddress: (state, action) => {
      state.billingCartAddress = action.payload;
    },
    setIsShippingAvailable: (state, action) => {
      state.isShippingAvailable = action.payload;
    },
    setDiscountCart: (state, action) => {
      state.discountCart = action.payload;
    },
    resetDiscountCart: (state, action) => {
      state.discountCart = initialState.discountCart;
    },
    setIsStorePickup: (state, action) => {
      state.isStorePickup = action.payload;
    },
    setErrorAmountPrice: (state, action) => {
      state.errorAmountPrice = action.payload;
    },
    setIsGiftOrder: (state, action) => {
      state.isGiftOrder = action.payload;
    },
    setGiftData: (state, action) => {
      state.giftData = action.payload;
    },
    setAppliedCoupon: (state, action) => {
      state.appliedCoupon = action.payload;
    },
    setContactInfo: (state, action) => {
      state.contactInfo = action.payload;
    },
    setGiftCard: (state, action) => {
      //! PDTE REVISAR!
      state.giftCard = action.payload;
      // const ivaPorc = 0.04;
      // const giftCardDiscount = parseFloat(state.giftCard?.discount_amount);
      // const giftCardIva = giftCardDiscount * ivaPorc;
      // const giftCardSubtotal = giftCardDiscount - giftCardIva;
      // const giftCardTotal = giftCardSubtotal + giftCardIva;

      state.countItems += 1;
      // state.iva = Number(parseFloat(state.iva) + giftCardIva).toFixed(4);
      // state.subtotal = Number(parseFloat(state.subtotal) + giftCardSubtotal).toFixed(4);
      state.total = Number((parseFloat(state.total) + state.giftCard?.discount_amount).toFixed(4));
      // const removeShippingCostGiftCard = Math.abs(parseFloat(state.total) - giftCardTotal).toFixed(4);
      state.lastAddedItem = 'Tarjeta regalo';
      state.isIncrease = true;
      state.hasGiftCard = true;
    },
    removeGiftCard: (state) => {
      //! PDTE REVISAR!
      state.lastRemovedItem = 'Tarjeta regalo';
      // const ivaPorc = 0.04;s
      // const giftCardDiscount = parseFloat(state.giftCard.discount);
      // const giftCardIva = giftCardDiscount * ivaPorc;
      // const giftCardSubtotal = giftCardDiscount - giftCardIva;
      // const giftCardTotal = giftCardSubtotal + giftCardIva;

      // state.iva = Number(parseFloat(state.iva) - giftCardIva).toFixed(4);
      // state.subtotal = Number(parseFloat(state.subtotal) - giftCardSubtotal).toFixed(4);
      // state.total = Number((parseFloat(state.total) - giftCardTotal).toFixed(2));
      // state.countItems -= 1;
      // state.isIncrease = true;
      // state.countItems = state.items.length;
      // state.hasGiftCard = false;
      // state.isIncrease = false;
      // state.giftCard = initialState.giftCard;
      state.total = Number((parseFloat(state.total) - parseFloat(state.giftCard?.discount_amount || 0)).toFixed(4));

      // Restablecer los valores relacionados con la tarjeta de regalo
      state.hasGiftCard = false;
      state.giftCard = initialState.giftCard;
      state.lastRemovedItem = 'Tarjeta regalo';
      state.isIncrease = false;

      // Asegurarse de que countItems refleje solo los productos reales
      state.countItems = state.items.length;
    },
  },
});

export const {
  addItem,
  removeItem,
  increaseQuantity,
  decreaseQuantity,
  clear,
  setShippingFee,
  setShippingCartAddress,
  setBillingCartAddress,
  setIsShippingAvailable,
  setDiscountCart,
  resetDiscountCart,
  setIsStorePickup,
  setErrorAmountPrice,
  setIsGiftOrder,
  setGiftData,
  setAppliedCoupon,
  setGiftCard,
  setContactInfo,
  removeGiftCard,
  setTotalWithDiscount,
  // clearGiftCard,
} = cartSlice.actions;
export const cartSelector = (state) => state.cart;
export default cartSlice.reducer;
